import type { WeeklyScheduleSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../../types'
import {
  fetchWeeklySchedule,
  type FetchOneWeeklyScheduleOptions
} from '../weeklySchedule.api'
import { weeklyScheduleApiCacheKeys } from '../weeklySchedule.api.cacheKeys'

export const useFetchWeeklySchedule = (
  request: FetchOneWeeklyScheduleOptions,
  queryOptions?: UseAppQueryOptions<WeeklyScheduleSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: weeklyScheduleApiCacheKeys.fetchOne({
      ...request?.queryParams,
      ...request.pathParams
    }),
    queryFn: () => fetchWeeklySchedule(request)
  })
}
